<template>
  <div class="row navigation">
    <div class="col-md-3">
      <div class="box box-primary">
        <div class="box-header">
          <h3>{{ $t('fileBrowser.folders.title') }}</h3>
        </div>
        <div class="box-body">
          <form class="navigation-filter">
            <div class="form-group">
              <i class="fa fa-search"></i>
              <input type="text" class="form-control" v-model="treeFilter" :placeholder="$t('fileBrowser.folders.search')">
            </div>
          </form>
          <LiquorTree
            :options="treeOptions"
            :filter="treeFilter"
            v-model="selectedNode"
          >
            <div class="tree-scope" slot-scope="{ node }">
              <div class="navigation-tree">
                <template>
                  <span class="text">
                    {{ node.text }}
                  </span>
                  <span class="release">
                    {{ $tc('fileBrowser.folders.elements', node.data.nbElement) }}
                  </span>
                </template>
              </div>
            </div>
          </LiquorTree>
        </div>
      </div>
      <div>
        <div class="box box-primary" v-if="uploadFiles.length > 0">
          <div class="box-header">
            <h3>{{ $t('fileBrowser.files.upload_in_progress') }}</h3>
          </div>
          <div class="box-body">
            <ul class="nav nav-stacked">
              <li v-for="file in uploadFiles" v-bind:key="file.data.id">
                <a href="#" v-if="file.success">
                  {{file.name}}
                  <span class="pull-right badge bg-green"><i class="fa fa-check" aria-hidden="true"></i></span>
                </a>
                <a href="#" v-else-if="file.error">
                  {{file.name}}
                  <span class="pull-right badge bg-red"><i class="fa fa-times" aria-hidden="true"></i></span>
                  <br />
                  <span class="text-red" v-if="file.error === 'size'">
                    {{ $t('fileBrowser.files.upload_error_size') }}
                  </span>
                  <span class="text-red" v-else>
                    {{ $t('fileBrowser.files.upload_error') }}
                  </span>
                </a>
                <a href="#" v-else>
                  {{file.name}}
                  <span class="pull-right badge"><i class="fa fa-spinner fa-spin" aria-hidden="true"></i></span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-9">
      <ShowSharepointLink v-if="isSharepoint" :sharepoint-link="sharepointUrl"/>
      <BrowserFileList v-else />

    </div>
  </div>
</template>

<script>
import LiquorTree from 'liquor-tree'
import { mapActions, mapState } from 'vuex'
import Store from '../../store/store'
import BrowserFileList from './BrowserFileList'
import ShowSharepointLink from '../sharepoint/ShowSharepointLink'

export default {
  name: 'BrowserFile',
  components: {
    LiquorTree,
    BrowserFileList,
    ShowSharepointLink
  },
  data () {
    return {
      urlPost: process.env.VUE_APP_API_BASE_URL,
      treeFilter: '',
      treeOptions: {
        multiple: false,
        filter: {
          plainList: true,
          emptyText: this.$t('fileBrowser.folders.not_found')
        },
        store: {
          store: Store,
          getter: () => {
            return Store.getters['drive/getTree']
          },
          dispatcher (tree) {
            Store.dispatch('drive/setTree', tree)
          }
        }
      }
    }
  },
  computed: {
    selectedNode: {
      get () { return this.$store.state.drive.selectedNode },
      set (val) {
        this.setSelectedNode({ selectedNode: val })
      }
    },
    uploadFiles: {
      get () {
        return this.$store.state.drive.uploadFiles
      },
      set (val) {
        this.$store.dispatch('drive/setUploadFiles', { uploadFiles: val })
      }
    },
    ...mapState('drive', [
      'treeData'
    ]),
    ...mapState('user', [
      'main'
    ]),
    canUpload () {
      return this.selectedNode && this.selectedNode.data.permissions && this.selectedNode.data.permissions.includes('create')
    },
    isSharepoint () {
      return false
      // return this.selectedNode && this.selectedNode.data.isSharepoint === true
    },
    sharepointUrl () {
      if (this.selectedNode) {
        return this.selectedNode.data.url
      }

      return ''
    }
  },
  mounted () {
    this.getMyTree()
  },
  methods: {
    ...mapActions('drive', {
      getMyTree: 'getTree'
    }),
    ...mapActions('drive', [
      'setSelectedNode'
    ])
  }
}
</script>

<style lang="scss" scoped>
  .navigation {
    height: calc(100vh - 130px);
    overflow-y: scroll;
  }

  .navigation-filter {
    margin-top: -10px;
    padding-left: 5px;
    padding-right: 5px;

    input {
      padding-left: 35px;
      font-style: italic;
    }

    .fa-search {
      position: relative;
      left: 10px;
      top: 26px;
      color: #999;
    }
  }

  .tree-arrow.has-child:after {
    position:absolute;
    top:10px;
    border: 0;
    font: normal normal normal 18px FontAwesome;
    line-height: 18px;
    transform: rotate(0deg) translateY(-50%);
  }

  .tree-arrow.expanded.has-child:after {
    transform: rotate(90deg) translateY(-4px) translateX(2px);
  }

  .tree-node.selected > .tree-content {
    background: #398df0;
  }

  .tree-node.selected > .tree-content > .tree-anchor {
    color: #fff;
  }

  .tree-content {
    padding: 2px 0;
  }

  .tree-scope {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  .release {
    color: #a9a9a9;
  }
</style>
